var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppCreativeCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_344)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.8782,
    cy: 19.8778,
    r: 23.1272,
    transform: "rotate(17.9456 26.8782 19.8778)",
    fill: "url(#paint0_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.11525,
    cy: 29.3833,
    r: 17.6449,
    transform: "rotate(17.9456 -1.11525 29.3833)",
    fill: "url(#paint1_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.3976,
    cy: 3.89777,
    r: 39.8261,
    transform: "rotate(17.9456 48.3976 3.89777)",
    fill: "url(#paint2_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.6758,
    cy: -4.82495,
    r: 29.2809,
    transform: "rotate(17.9456 21.6758 -4.82495)",
    fill: "url(#paint3_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.87826,
    cy: 53.8777,
    r: 27.2614,
    transform: "rotate(17.9456 2.87826 53.8777)",
    fill: "url(#paint4_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.33482,
    cy: 39.8338,
    r: 20.4621,
    transform: "rotate(17.9456 8.33482 39.8338)",
    fill: "url(#paint5_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.8782,
    cy: 7.87818,
    r: 29.2809,
    transform: "rotate(17.9456 4.8782 7.87818)",
    fill: "url(#paint6_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4761,
    cy: 59.4764,
    r: 40.1243,
    transform: "rotate(17.9456 53.4761 59.4764)",
    fill: "url(#paint7_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.195,
    cy: 52.1966,
    r: 15.4931,
    transform: "rotate(17.9456 25.195 52.1966)",
    fill: "url(#paint8_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8976,
    cy: 34.8964,
    r: 24.091,
    transform: "rotate(17.9456 36.8976 34.8964)",
    fill: "url(#paint9_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.6436,
    cy: 48.9185,
    r: 13.4362,
    transform: "rotate(17.9456 15.6436 48.9185)",
    fill: "url(#paint10_radial_21_344)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.7751,
    cy: 36.7752,
    r: 13.6698,
    transform: "rotate(17.9456 39.7751 36.7752)",
    fill: "url(#paint11_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.6758,
    cy: -4.82495,
    r: 29.2809,
    transform: "rotate(17.9456 21.6758 -4.82495)",
    fill: "url(#paint12_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2182,
    cy: 19.7185,
    r: 12.0647,
    transform: "rotate(17.9456 53.2182 19.7185)",
    fill: "url(#paint13_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.3417,
    cy: 33.8431,
    r: 16.8469,
    transform: "rotate(17.9456 52.3417 33.8431)",
    fill: "url(#paint14_radial_21_344)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3573,
    cy: 23.7463,
    rx: 13.9473,
    ry: 6.77877,
    transform: "rotate(17.9456 16.3573 23.7463)",
    fill: "url(#paint15_radial_21_344)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.10958,
    cy: 13.2108,
    rx: 11.9252,
    ry: 8.973,
    transform: "rotate(17.9456 4.10958 13.2108)",
    fill: "url(#paint16_radial_21_344)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10958,
    cy: 6.21076,
    rx: 11.9252,
    ry: 8.973,
    transform: "rotate(17.9456 5.10958 6.21076)",
    fill: "url(#paint17_radial_21_344)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.1066,
    cy: 31.1065,
    r: 12.7884,
    transform: "rotate(17.9456 42.1066 31.1065)",
    fill: "url(#paint18_radial_21_344)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.9211,
    cy: 49.9219,
    r: 16.0318,
    transform: "rotate(17.9456 3.9211 49.9219)",
    fill: "url(#paint19_radial_21_344)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.589 16.5698C39.8653 13.6231 36.1356 12 32.0869 12C28.2027 12 24.2521 13.677 21.7251 16.3882C21.2637 16.3357 20.7953 16.3092 20.33 16.3092C12.714 16.3092 8 22.7604 8 28.7375C8 31.9002 9.26066 35.0619 11.4588 37.4115C13.7901 39.9034 16.9406 41.2755 20.33 41.2755H32.0869C40.0667 41.2755 46.5586 34.6872 46.5586 26.5888C46.5586 22.9508 45.1118 19.2989 42.589 16.5698ZM20.1105 39.1568C14.4776 39.1568 9.89496 34.5223 9.89496 28.8261C9.89496 23.1667 14.4565 18.5626 20.0633 18.5626C22.5928 18.5626 25.0045 19.4866 26.8572 21.1652L26.9073 21.2087L31.1436 25.5863C31.4823 25.9316 31.6668 26.3953 31.6617 26.8896C31.6568 27.3779 31.4604 27.8365 31.1089 28.1808C30.7672 28.5144 30.3161 28.6981 29.8383 28.6981C29.3401 28.6981 28.875 28.5004 28.5284 28.1414L24.3247 23.7972C23.1411 22.7717 21.6298 22.2072 20.0672 22.2072C16.4714 22.2072 13.546 25.1477 13.546 28.7624C13.546 32.3692 16.5972 35.4166 20.209 35.4166L21.0481 35.4205L21.0559 35.4443C22.2573 37.1134 25.6038 39.1568 25.6038 39.1568H20.1105ZM41.0573 35.4533C38.7091 37.8876 35.5995 39.2282 32.3007 39.2282C29.1646 39.2282 25.9615 37.8163 23.513 35.3545L17.9139 29.7042C17.2112 28.9764 17.2265 27.8113 17.9446 27.103C18.2897 26.766 18.7423 26.5808 19.22 26.5808C19.7182 26.5808 20.1821 26.7775 20.526 27.1339L26.0858 32.7482C27.851 34.5299 30.1163 35.5517 32.3007 35.5517C34.6182 35.5517 36.8041 34.6 38.4559 32.8722C40.1046 31.1508 41.0126 28.8965 41.0126 26.5247C41.0126 21.6721 37.0904 17.724 32.2693 17.724C30.4304 17.724 28.9108 18.082 27.4268 19.1459C27.4107 19.1328 27.0086 18.8644 26.5545 18.5865C26.2729 18.4141 25.9696 18.2426 25.7309 18.1122C25.4654 17.9668 24.7041 17.5907 24.2512 17.4022C24.1385 17.3552 23.9929 17.3014 23.9316 17.2796L23.9444 17.2727C26.2489 15.1034 29.1167 14.0475 32.2693 14.0475C39.1036 14.0475 44.6636 19.6448 44.6636 26.5247C44.6636 29.8668 43.3828 33.0375 41.0573 35.4533Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8782 19.8778) rotate(90) scale(23.1272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD109A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD109A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.11525 29.3833) rotate(90) scale(17.6449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D57FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D57FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3976 3.89777) rotate(90) scale(39.8261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4201",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6758 -4.82494) rotate(90) scale(29.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.87826 53.8777) rotate(90) scale(27.2614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3988FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#3988FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3988FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.33482 39.8338) rotate(90) scale(20.4621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3987FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.8782 7.87818) rotate(90) scale(29.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD109A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD109A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4761 59.4764) rotate(90) scale(40.1243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#6CE342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE342",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.195 52.1966) rotate(90) scale(15.4931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B5AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8976 34.8964) rotate(90) scale(24.091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED20F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6436 48.9185) rotate(90) scale(13.4362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3987FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3987FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7751 36.7752) rotate(90) scale(13.6698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD61D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6758 -4.82494) rotate(90) scale(29.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2182 19.7185) rotate(90) scale(12.0647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3417 33.8431) rotate(90) scale(16.8469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED20F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3573 23.7463) rotate(90) scale(6.77877 13.9473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE53EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE53EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.10958 13.2108) rotate(90) scale(8.973 11.9252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F91CB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.10958 6.21076) rotate(90) scale(8.973 11.9252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F91CB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1066 31.1065) rotate(90) scale(12.7884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB902",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_21_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.9211 49.9219) rotate(90) scale(16.0318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358AFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppCreativeCloud);
export default __webpack_public_path__ + "static/media/B_app_CreativeCloud.ba02a1b93cbaef8043dee26926c7b677.svg";
export { ForwardRef as ReactComponent };